let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hYYP2")).then(() => parcelRequire('f4oZQ'));